/**
 * Saudi National ID / Iqama validation (frontend)
 *
 * Mirrors backend/src/lib/iqama.ts
 *
 * Saudi residency document numbers:
 *   - Exactly 10 digits
 *   - Starts with '1' (National ID for Saudi citizens)
 *   - Or starts with '2' (Iqama for non-Saudi residents)
 */

export interface IqamaValidation {
  valid: boolean;
  error?: string;
  type?: 'national_id' | 'iqama';
}

export function validateIqama(input: string | null | undefined): IqamaValidation {
  if (!input || typeof input !== 'string' || input.length === 0) {
    return { valid: false, error: 'Required' };
  }

  const trimmed = input.replace(/\s|-/g, '');

  if (!/^\d+$/.test(trimmed)) {
    return { valid: false, error: 'Digits only' };
  }

  if (trimmed.length !== 10) {
    return {
      valid: false,
      error: `Must be 10 digits (got ${trimmed.length})`,
    };
  }

  if (!/^[12]/.test(trimmed)) {
    return {
      valid: false,
      error: 'Must start with 1 (Saudi ID) or 2 (Iqama)',
    };
  }

  return {
    valid: true,
    type: trimmed.startsWith('1') ? 'national_id' : 'iqama',
  };
}

/**
 * Sanitize input as user types — only digits, max 10
 */
export function sanitizeIqama(input: string): string {
  return input.replace(/[^0-9]/g, '').slice(0, 10);
}
